import React from "react";

const Redo1svg = () => {
	return (
		<>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				// width="512"
				// height="512"
				viewBox="0 0 20 20"
				// viewBox="0 0 100 100"
				x="0px"
				y="0px"
				width={24}
				height={24}
				fill="currentColor"
			>
				<path
					// fill="#000000"
					fill="#68AFFD"
					d="M7.94.56a8.05 8.05 0 0 1 6.82 3.64V1.55H16V5a1.16 1.16 0 0 1-1.15 1.15h-3.44V4.9h2.32a6.79 6.79 0 0 0-5.79-3.1A6.48 6.48 0 0 0 1.24 8a6.48 6.48 0 0 0 6.7 6.2a6.48 6.48 0 0 0 6.7-6.2h1.24a7.71 7.71 0 0 1-7.94 7.44A7.71 7.71 0 0 1 0 8A7.71 7.71 0 0 1 7.94.56z"
				/>
			</svg>
		</>
	);
};

export default Redo1svg;
